export default {
  pillars: {
    sectionTitle: 'Guías y recursos de Basetao',
    sectionSubtitle:
      'Guías prácticas sobre hojas de cálculo, envío, QC, vendedores, seguridad y más.',
    readMore: 'Leer la guía',
    guide: {
      title: 'La guía completa de la hoja de cálculo de Basetao',
      desc: 'Crea y usa una hoja de cálculo de Basetao para organizar enlaces, vendedores, QC y envío.',
    },
    review: {
      title: 'Reseña de Basetao',
      desc: 'Cómo funciona el agente Basetao, sus ventajas y limitaciones.',
    },
    shipping: {
      title: 'Guía de costes de envío de Basetao',
      desc: 'Entiende cómo se calculan los costes de envío y cómo ahorrar.',
    },
    warehouse: {
      title: 'Guía del almacén de Basetao',
      desc: 'Cómo funcionan el almacenamiento, la consolidación y el QC en el almacén de Basetao.',
    },
    qc: {
      title: 'Guía de QC y control de calidad de Basetao',
      desc: 'Qué revisar en las fotos de QC y cómo detectar problemas a tiempo.',
    },
    sellers: {
      title: 'Guía de vendedores de confianza de Basetao',
      desc: 'Cómo evaluar y elegir vendedores fiables para tu pedido.',
    },
    coupons: {
      title: 'Cupones y códigos de descuento de Basetao',
      desc: 'Dónde encontrar descuentos y cómo usarlos con honestidad.',
    },
    safety: {
      title: '¿Basetao es legítimo y seguro?',
      desc: 'Pasos prácticos para proteger tu cuenta, pagos y compras.',
    },
    vs: {
      title: 'Comparativa Basetao vs Superbuy',
      desc: 'Compara tarifas, funciones y flujo de trabajo de dos agentes populares.',
    },
    beginner: {
      title: 'Guía para principiantes de Basetao',
      desc: 'Una guía sencilla paso a paso para tu primer pedido en Basetao.',
    },
  },
};